const API_ERROR_FEATURE = 'API Error'

const getAnalyticsError = (
  operationType: string,
  operationName: string,
  errorCode: number | null,
) => ({
  operation_type: operationType,
  operation_name: operationName,
  feature: API_ERROR_FEATURE,
  'Event Description': 'Occurred',
  Object: 'Error',
  Action: 'Received',
  object_name: 'clientNetworkError',
  error_code: `${errorCode || ''}`,
  source: '',
  error_details: '',
})

const getGraphQLError = (
  operationType: string,
  operationName: string,
  errorCode: number | null,
  error: any,
) => ({
  ...getAnalyticsError(operationType, operationName, errorCode),
  source: 'graphql',
  error_details: error?.debugStacktrace
    ? JSON.stringify(error.debugStacktrace)
    : error.status,
})

export const trackGraphQLError = (
  analytics: any,
  operationType: string,
  operationName: string,
  errorCode: number | null,
  error: any,
) => {
  analytics.track(
    API_ERROR_FEATURE,
    getGraphQLError(operationType, operationName, errorCode, error),
  )
}
